<template>
    <list-search v-bind="{ loading }" showsSearch @search="push">
        <v-row align="center" class="ma-n2">
            <!-- <v-col cols="12" md="4" lg="" class="pa-2">
                <v-text-field label="기간(시작)" v-model="query.dates[0]" type="date" v-bind="attrs_input" clearable />
            </v-col>
            <v-col cols="12" md="4" lg="" class="pa-2">
                <v-text-field label="기간(종료)" v-model="query.dates[1]" type="date" v-bind="attrs_input" clearable />
            </v-col> -->
            <v-col cols="12" md="4" lg="3" class="pa-2">
                <v-select label="검색유형" v-model="query.searchKey" :items="searchKeys" placeholder="전체" clearable v-bind="attrs_input" />
            </v-col>
            <v-col cols="12" md="4" lg="3" class="pa-2">
                <v-text-field label="검색어" v-model="query.searchValue" clearable v-bind="attrs_input" @keydown.enter="push" />
            </v-col>
        </v-row>
    </list-search>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import ListSearch from "@/components/console/dumb/list-search.vue";

let initQuery = () => ({
    dates: [],
    searchKey: null,
    searchValue: null,
});

let searchKeys = [
    { text: "자재코드", value: "code" },
    { text: "자재설명", value: "name" },
    { text: "제조사", value: "maker" },
];

export default {
    components: {
        ListSearch,
    },
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        searchKeys,

        attrs_input,
    }),
    mounted() {
        this.sync();
    },

    methods: {
        sync() {
            this.query = { ...initQuery(), ...this.$route.query };
        },
        push() {
            let { query: { ...query } = {} } = this;

            let hasStartDate = !!query?.dates?.[0];
            let hasEndDate = !!query?.dates?.[1];
            if (!hasStartDate && hasEndDate) throw new Error("시작 날짜를 설정해주세요");
            if (hasStartDate && !hasEndDate) throw new Error("종료 날짜를 설정해주세요");
            if (!hasStartDate && !hasEndDate) delete query.dates;

            query.page = 1;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
